import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wms-dialog-body',
  standalone: true,
  templateUrl: './wms-dialog-body.component.html',
  styleUrls: ['./wms-dialog-body.component.less']
})
export class WmsDialogBodyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
